import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { MobileProfileHeader } from '../../../sharedDisplays/headers/MobileProfileHeader'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  asset: AssetReference
  isPresenting: boolean
  onExpandAsset: (id: number) => void
  onRemoveAsset: (id: number) => void
  readOnly: boolean
  updateCoverAsset: (val: string, id?: number) => void
}

export const MobileProfile: React.FC<Props> = ({
  accountImage,
  accountName,
  asset,
  isPresenting,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  updateCoverAsset,
}) => {
  return (
    <Fragment>
      <MobileProfileHeader
        accountName={accountName}
        accountImage={accountImage}
        centerTab="instagram-mobile-profile-reel"
      />
      <div
        css={styles.contentWrapper}
        className={kuiperClassNames('reels-thumbnail-preview')}
      >
        <Asset
          assetReference={asset}
          disableMediaControls={true}
          hasAssetOptions={true}
          hasAssetOverlay={asset && (!readOnly || isPresenting)}
          onEmbiggen={() => onExpandAsset(asset.id || 0)}
          onRemove={() => onRemoveAsset(asset.id || 0)}
          placeholder={!asset}
          updateCoverAsset={(val: string) => updateCoverAsset(val, asset.id)}
          overrideStyles={{
            assetBase: styles.assetBaseStyles,
            asset: styles.assetStyles,
          }}
        />
        <div css={styles.thumbnailFooter}>
          {renderIcon('instagram-mobile-play-inverted', {
            height: 13,
            width: 16,
            ariaMode: 'hidden',
          })}
          ###
        </div>
      </div>
    </Fragment>
  )
}
